<template>
  <div class="info-container">

    <div>
      <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
      >

        <b-carousel-slide
            v-for="item in filteredImages"
            :key="item._id"
            :caption="item.description"
            :img-src="item.link"
            img-width="1024"
            img-height="480"
        >
        </b-carousel-slide>
      </b-carousel>


    </div>


  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
export default {
  data() {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods:{
    ...mapActions(["getImages"]),
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }

  },
  computed: {
    ...mapGetters(["filteredImages"]),
    ...mapState(["images"])
  },
  created() {
    this.getImages()
  }
};


</script>

<style>
.info-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
